// extracted by mini-css-extract-plugin
export default {"createlUser":"create_createlUser__d6M6G","header":"create_header__8+mFJ","content":"create_content__5YCTq","titlePage":"create_titlePage__+76ZW"};